import { useEffect } from 'react';
import toastr from 'toastr';

const lang = localStorage.getItem("lang")


export const successMsg = (message) => {
    toastr.success('', message, {
        closeButton: true, timeOut: 3000, rtl: lang == "ar" ? true : false,
        positionClass: lang == "ar" ? 'toast-top-left' : 'toast-top-right'
    });
};


export const errorMsg = (message, position) => {
    toastr.error('', message, {
        closeButton: true, timeOut: 3000,  rtl: lang == "ar" ? true : false,
        positionClass: lang == "ar" || position == "left" ? 'toast-top-left' : 'toast-top-right'
    });
};

const useToastr = () => {

    const success = (message) => {
        successMsg(message)
    };

    const error = (message, position) => {
        errorMsg(message, position)
    };

    return {
        success,
        error,
    };
};

export default useToastr;
